import _asyncToGenerator from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import utils from '@/utils';
import table from '@/mixins/crud-table.js';
import './style.scss';
import { request } from '@/api/service';
export default {
  mixins: [table],
  components: {
    componentForm: function componentForm() {
      return import('./form');
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var page = h("d2-container", {
      "attrs": {
        "spacious": true
      },
      "class": "page-management-user"
    }, [h("d2-search-panel", {
      "slot": "header",
      "model": {
        value: _this.search.panel.active,
        callback: function callback($$v) {
          _this.$set(_this.search.panel, "active", $$v);
        }
      }
    }, [h("d2-bar", {
      "slot": "title"
    }, [h("d2-bar-space"), this.p('query') ? h("d2-bar-cell", [this.vNodePaginationMini]) : h("d2-bar-cell", [this.vNodeSearchPanelAlertNoPermissionQuery]), h("d2-bar-space"), h("d2-bar-cell", [h("el-button-group", [this.p('query') ? this.vNodeButtonSearch : null, this.vNodeButtonTableColumnsFilterTrigger])]), this.p('add') ? h("d2-bar-cell", [this.vNodeButtonCreate]) : null]), this.p('query') ? this.vNodeSearchForm : null]), h("el-container", {
      "class": "container"
    }, [h("el-aside", {
      "directives": [{
        name: "permission",
        value: 'system:dept:query'
      }],
      "attrs": {
        "width": "240px"
      }
    }, [h("d2-tree", {
      "attrs": {
        "source": "DEPT_ALL",
        "key-label": "dept_name",
        "expand-on-click-node": false,
        "default-expand-all": true
      },
      "on": {
        "change": this.research
      },
      "model": {
        value: _this.search.form.model.dept_id,
        callback: function callback($$v) {
          _this.$set(_this.search.form.model, "dept_id", $$v);
        }
      }
    })]), h("el-main", [this.vNodeTable])]), h("d2-bar", {
      "slot": "footer"
    }, [h("d2-bar-cell", [this.vNodePaginationFull]), h("d2-bar-space")]), h("component-form", {
      "ref": "form",
      "on": {
        "success": this.research
      }
    }), this.vNodeTableColumnsFilter]);
    return page;
  },
  data: function data() {
    return {
      api: {
        index: 'USER_ALL',
        delete: 'USER_DELETE'
      },
      permission: {
        query: 'system:user:query',
        add: 'system:user:add',
        edit: 'system:user:edit',
        remove: 'system:user:remove'
      }
    };
  },
  computed: {
    // 配置项
    // 表格列
    // 建议的书写顺序 [prop] -> [label] -> [align] -> [minWidth][width] -> [fixed] -> [other] -> [render][formatter] -> [if][show]
    settingColumns: function settingColumns() {
      var h = this.$createElement;
      return [{
        prop: 'user_name',
        label: '登录账号',
        minWidth: '100px',
        fixed: 'left'
      }, {
        prop: 'nickname',
        label: '昵称',
        minWidth: '100px'
      }, {
        prop: 'id',
        label: 'ID',
        minWidth: '80px'
      }, {
        prop: 'sex',
        label: '性别',
        minWidth: '80px',
        render: function render(_ref) {
          var row = _ref.row;
          return h("d2-dict", {
            "attrs": {
              "name": "sex",
              "value": row.sex,
              "all": true,
              "all-label": "未知"
            }
          });
        }
      }, {
        prop: 'avatar',
        label: '头像',
        minWidth: '80px',
        render: function render(_ref2) {
          var row = _ref2.row;
          return h("el-image", {
            "attrs": {
              "src": row.avatar,
              "fit": "cover",
              "preview-src-list": [row.avatar],
              "lazy": true
            },
            "style": "height: 28px; width: 28px; border-radius: 2px;"
          }, [h("div", {
            "slot": "error",
            "style": "height: 100%; width: 100%;",
            "attrs": {
              "flex": "main:center cross:center"
            }
          }, [h("i", {
            "class": "el-icon-picture-outline"
          })])]);
        }
      }, {
        prop: 'email',
        label: '邮箱',
        minWidth: '160px'
      }, {
        prop: 'phone',
        label: '手机',
        minWidth: '100px'
      }, {
        prop: 'phonenumber',
        label: '座机',
        minWidth: '100px'
      }, {
        prop: 'dept_id',
        label: '归属部门',
        width: '100px',
        render: function render(_ref3) {
          var row = _ref3.row;
          return h("d2-dict", {
            "attrs": {
              "name": "dept_id",
              "value": row.dept_id,
              "custom": true
            }
          });
        },
        if: this.$permission('system:dept:query')
      }, {
        prop: 'login_date',
        label: '上次登录时间',
        width: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.login_date, 'YYYY/M/D HH:mm:ss');
        }
      }, {
        prop: 'login_ip',
        label: '上次登录地址',
        width: '120px'
      }, {
        prop: 'remark',
        label: '备注',
        width: '100px'
      }, {
        prop: 'status',
        label: '状态',
        width: '100px',
        render: function render(_ref4) {
          var row = _ref4.row;
          return h("d2-dict", {
            "attrs": {
              "name": "status",
              "value": row.status
            }
          });
        }
      }, {
        prop: 'create_by',
        label: '创建人员',
        width: '100px',
        show: false
      }, {
        prop: 'created_at',
        label: '创建时间',
        width: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.created_at, 'YYYY/M/D HH:mm:ss');
        }
      }, {
        prop: 'update_by',
        label: '更新人员',
        width: '100px',
        show: false
      }, {
        prop: 'updated_at',
        label: '更新时间',
        width: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.updated_at, 'YYYY/M/D HH:mm:ss');
        }
      }].map(function (setting) {
        setting.sortable = 'custom';
        return setting;
      });
    },
    // 配置项
    // 表格操作列配置
    settingActionsConfig: function settingActionsConfig() {
      var _this2 = this;

      return function (_ref5) {
        var row = _ref5.row;
        return [].concat(_toConsumableArray(_this2.p('edit', [{
          icon: 'el-icon-sms',
          label: '短信充值',
          action: function action() {
            return _this2.go_sms_recharge(row.id);
          }
        }], [])), _toConsumableArray(_this2.p('edit', [{
          icon: 'el-icon-edit-outline',
          action: function action() {
            return _this2.edit(row.id);
          }
        }], [])), _toConsumableArray(_this2.p('remove', [{
          icon: 'el-icon-delete',
          type: 'danger',
          confirm: "\u786E\u5B9A\u5220\u9664 [ ".concat(row.user_name, " ] \u5417"),
          action: function action() {
            return _this2.delete(row.id);
          }
        }], [])));
      };
    },
    // 配置项
    // 表格搜索条件
    // 建议的书写顺序 [prop] -> [label] -> [default] -> [render] -> [if][show]
    settingSearch: function settingSearch() {
      var _this3 = this;

      var h = this.$createElement;
      return [{
        prop: 'user_name',
        label: '登录账号',
        default: '',
        render: function render() {
          return h("el-input", {
            "style": "width:100px;",
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this3.search.form.model.user_name,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "user_name", $$v);
              }
            }
          });
        }
      }, {
        prop: 'phone',
        label: '手机',
        default: '',
        render: function render() {
          return h("el-input", {
            "style": "width:100px;",
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this3.search.form.model.phone,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "phone", $$v);
              }
            }
          });
        }
      }, {
        prop: 'status',
        label: '状态',
        default: this.$env.VUE_APP_DICT_EMPTY_NUMBER,
        render: function render() {
          return h("d2-dict-radio", {
            "attrs": {
              "name": "status",
              "button": true,
              "all": true
            },
            "model": {
              value: _this3.search.form.model.status,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "status", $$v);
              }
            }
          });
        }
      }, {
        prop: 'start_time',
        label: 'start_time',
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "start_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this3.search.form.model.start_time,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "start_time", $$v);
              }
            }
          });
        }
      }, {
        prop: 'end_time',
        label: 'end_time',
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "end_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this3.search.form.model.end_time,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "end_time", $$v);
              }
            }
          });
        }
      }, {
        prop: 'dept_id',
        label: '部门',
        default: 0,
        show: false
      }];
    }
  },
  methods: {
    /**
    * @description 运营商短信充值，充到运营商，要区分充到设备的
    */
    go_sms_recharge: function go_sms_recharge(market_id) {
      var _this4 = this;

      request({
        method: 'post',
        url: '/api/sms-recharge/create',
        data: {
          market_id: market_id
        }
      }).then(function (res) {
        var app_id = res.app_id;
        var sign = res.sign;
        var market_id = res.market_id;
        var order_no = res.order_no;
        var sms_count = res.sms_count;
        var src = res.src;
        _this4.open = true;
        _this4.url = src + '?app_id=' + app_id + '&sign=' + sign + '&market_id=' + market_id + '&order_no=' + order_no + '&sms_count=' + sms_count;
        utils.open(_this4.url);
      });
    },

    /**
     * @description 加载需要的字典数据
     */
    loadDict: function loadDict() {
      var _this5 = this;

      // 归属部门
      if (this.$permission('system:dept:query')) {
        this.loadDictOne({
          name: 'dept_id',
          method: function () {
            var _method = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
              return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.t0 = utils.helper;
                      _context.next = 3;
                      return _this5.$api.DEPT_ALL();

                    case 3:
                      _context.t1 = _context.sent;
                      _context.t2 = {
                        data: _context.t1
                      };
                      return _context.abrupt("return", _context.t0.flatTreeToArray.call(_context.t0, _context.t2));

                    case 6:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));

            function method() {
              return _method.apply(this, arguments);
            }

            return method;
          }(),
          label: 'dept_name'
        });
      }
    }
  }
};